module.exports = __webpack_public_path__ + "static/media/google-play-badge.5352018c.png";